<template>
  <v-container
    id="resellers-reports"
    tag="section"
  >
    <v-card>
      <v-card-title>
        {{ title }} <v-spacer />
        <v-btn color="secondary" @click="exportData">
<v-icon>mdi-download</v-icon>
</v-btn>
      </v-card-title>
   <v-container>
    <v-row>
      <v-col>
        <v-text-field
            v-model="search"
            class="searchBox"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            single-line
            hide-details
            />
      </v-col>
        <v-spacer />
        <v-spacer />
        <v-spacer />
      <v-col>
     <v-autocomplete
      v-model="period"
      :items="months"
      item-text="name"
      item-value="id"
      label="Select a period"
      return-object
      autocomplete="off"
      @change="selectMonth(period)"
    >
    <template v-slot:append-item>
    <div v-intersect="onIntersect" class="pa-4 teal--text" />
    </template>
    </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
        <v-data-table
          filterable
          :headers="computedHeaders.map((x) => { return { ...x, text: $t(x.text) } })"
          :items="items"
          item-key="id"
          :loading="loading"
          :search="search"
          :items-per-page="rowsPerPage"
        >
          <template v-slot:item.reseller="{ item }">
                {{ item.resellerName }}
          </template>
          <template v-slot:item.totalSessions="{ item }">
                {{ item.totalSessions }}
          </template>
          <template v-slot:item.monthlySessions="{ item }">
                {{ item.monthlySessions }}
          </template>
          <template v-slot:item.activityChange="{ item }">
             <v-chip :color="activityChangeColor(item.activityChange)">
              {{ (item.activityChange > 0 ? "+" : "") }}{{ item.activityChange }}
              </v-chip>
          </template>
          <template v-slot:item.standardAccounts="{ item }">
                {{ item.standardAccounts }}
          </template>
          <template v-slot:item.trialAccounts="{ item }">
                {{ item.trialAccounts }}
          </template>
          <template v-slot:item.numberOfAdmins="{ item }">
                {{ item.numberOfAdmins }}
          </template>
          <template v-slot:item.expiryDate="{ item }">
              <span :class="textColor(item.expiryDate)"> {{ displayTime(item.expiryDate) }}</span>
          </template>
        </v-data-table>
    </v-card>
  <v-card v-if="userRoleIs('developer')">
      <v-card-title>Report Management</v-card-title>
      <v-card-text>
        <v-form class="red--text">
          <date-range-picker :text-color="datePickerColor" @datesChange="reportDatesChanged" />
          <v-btn color="blue" :disabled="query.processingReport" @click="generateNewReport">
Create
</v-btn>
          <v-btn color="red" :disabled="query.processingReport" @click="deleteReport">
Delete
</v-btn>
          <p>
<span color="red">
          {{ error }}
        </span>
          </p>
        </v-form>
      </v-card-text>
    </v-card>
  <v-overlay :value="busy">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
<script>
  import api from '@/helpers/api.js'
  import moment from 'moment'
  import DateRangePicker from './DateRangePicker'
  export default {
    components: {
      'date-range-picker': DateRangePicker,
    },
    data () {
      return {
        title: 'Resellers report',
        reportType: 'ResellersReport',
        search: '',
        datePickerColor: 'blacktext',
        rowsPerPage: 15,
        period: new Date(new Date().setDate(0)).toISOString().substr(0, 7),
        modal: false,
        items: [],
        months: [],
        error: '',
        reports: [],
        loading: false,
        startDate: '',
        endDate: '',
        query: { startDate: moment().startOf('month').toDate(), endDate: moment().endOf('month').toDate(), processingReport: false },
        headers: [
          { text: 'resellersReports.headers.reseller', sortable: true, value: 'reseller' },
          { text: 'resellersReports.headers.total-sessions', sortable: true, align: 'center', value: 'totalSessions' },
          { text: 'resellersReports.headers.monthly-sessions', sortable: true, align: 'center', value: 'monthlySessions' },
          { text: 'resellersReports.headers.activity-change', sortable: true, align: 'center', value: 'activityChange' },
          { text: 'resellersReports.headers.standard-accounts', sortable: true, align: 'center', value: 'standardAccounts' },
          { text: 'resellersReports.headers.trial-accounts', sortable: true, align: 'center', value: 'trialAccounts' },
          { text: 'resellersReports.headers.registered-admins', sortable: true, align: 'center', value: 'numberOfAdmins' },
          { text: 'resellersReports.headers.expiry', sortable: true, align: 'center', value: 'expiryDate' },
        ],
      }
    },
    computed: {
      computedHeaders () {
        return this.headers
      },
      busy () {
        return this.loading
      },
    },
    async mounted () {
      await this.getAllResellersReport()
      await this.refreshItems()
    },
    async created () {
      this.loading = true
      await this.getAllResellersReport()
      await this.refreshItems()
      this.loading = false
    },
    methods: {
      exportData () {
        let csv = 'Reseller,Sessions,Monthly Sessions,Activity Change, Standard Accounts,Trial Accounts, Number of Admins,Expiry date\n'
        console.log(this.items)
        this.items.forEach((row) => {
          csv += row.resellerName + ',' + row.totalSessions + ',' + row.monthlySessions + ',' + row.activityChange + ',' + row.standardAccounts + ',' + row.trialAccounts + ',' + row.numberOfAdmins + ',' + this.displayTime(row.expiryDate)
          csv += '\n'
        })
        const anchor = document.createElement('a')
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
        anchor.target = '_blank'
        anchor.download = 'Resellers Report.csv'
        anchor.click()
      },
      userRoleIs (role) {
        return (this.$store.getters.isAuthenticated && this.$store.getters.currentUserProfile.user.roles.includes(role))
      },
      reportDatesChanged (date) {
        this.query.startDate = date[0]
        this.query.endDate = date[1]
      },
      activityChangeColor (activityChange) {
        if (activityChange < 0) {
          return 'red lighten-1 white--text'
        } else if (activityChange > 0) {
          return 'green lighten-1 white--text'
        }
      },
      async getAllResellersReport () {
        const reportIntervals = []
        this.reports = await api.getAllResellersReport() || []
        for (let i = 0; i < this.reports.length; i++) {
          const startDate = moment(this.reports[i].startDate).format('YYYY-MM')
          reportIntervals.push(startDate)
        }
        this.months = reportIntervals.sort()
      },
      async selectMonth (date) {
        this.period = date
        this.startDate = moment(this.period, 'YYYY/MM').startOf('month').toDate()
        this.endDate = moment(this.period, 'YYYY/MM').endOf('month').toDate()
        this.modal = false
        await this.refreshItems()
      },
      async refreshItems () {
        this.loading = true
        this.startDate = moment(this.period, 'YYYY/MM').startOf('month').toDate()
        this.endDate = moment(this.period, 'YYYY/MM').endOf('month').toDate()
        const reportData = this.reports.filter(r => {
          return moment(this.startDate).isSame(moment(r.startDate).format('YYYY-MM-DD'))
        })
        if (reportData && reportData.length > 0) {
          this.items = reportData[0].report
        }
        this.loading = false
      },
      displayTime (time) {
        return moment(time).format('DD/MM/YY')
      },
      async generateNewReport () {
        // should validate
        console.log('start generate report')
        if (!this.query.startDate || !this.query.endDate) {
          console.error('no dates defined')
          return
        }
        try {
          this.query.processingReport = true
          await api.postResellersReport(this.query.startDate, this.query.endDate)
          await this.getAllResellersReport()
        } catch (ex) {
          this.error = ex.message
        }
        this.query.processingReport = false
        console.log('end report')
      },
      async deleteReport () {
        // should validate
        console.log('start delete report')
        if (!this.query.startDate || !this.query.endDate) {
          console.error('no dates defined')
          return
        }
        try {
          this.query.processingReport = true
          await api.deleteResellersReport(this.query.startDate, this.query.endDate)
          await this.getAllResellersReport()
        } catch (ex) {
          this.error = ex.message
        }
        this.query.processingReport = false
        console.log('end delete report')
      },
      onIntersect () {
        this.getAllResellersReport()
      },
      textColor (time) {
        const currentTime = moment(this.period)
        const differenceInMonths = moment(time).diff(currentTime, 'months')
        return differenceInMonths <= 3 ? 'status' : ''
      },
    },

  }
</script>
<style>
.headers {
    font-size: 10px !important
}
.monthBox {
  max-width: 200px;
  margin-bottom: 10px;
}
.status {
  color: red;
  margin-left: -13px;
}
</style>
